import { render } from "./index.vue?vue&type=template&id=7c85fce5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7c85fce5&scoped=true&lang=css"

import exportComponent from "E:\\web\\duty_new_2\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_9f64b88eef0ad2be2f27cb0deb411dda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c85fce5"]])

export default __exports__